<pm-form-field
  label="RESULT.KPIS.EXPORT_OPTIONS.XLSX_METADATA.FORECAST_VERSION"
>
  <pm-form-input-select
    [data]="availableVersionOptions()"
    sortByKey="sortBy"
    sortDirection="desc"
    [disabled]="isLoading()"
    [ngModel]="this.selectedVersionId()"
    (ngModelChange)="versionSelectionChanged($event)"
  >
    <div *pmFormInputSelection="let versionOption = node">
      @let version = versionOption.version;

      <div
        [class.pm-disabled]="versionOption.disabled || !version.isVisible"
        [pmTooltip]="versionOption.tooltip"
        [pmTooltipPosition]="'right'"
        [pmTooltipOffset]="120"
      >
        <div class="flex flex-row justify-center items-center">
          <pm-icon
            [ngClass]="{
              spin: version.status === ForecastVersionStatus.CALCULATING,
            }"
            [class]="twMerge('transition-all', 'text-unset')"
            matTextSuffix
            [icon]="versionOption.statusIcon"
            size="md"
          />

          <div class="ml-2 flex flex-col">
            <p>
              {{ versionOption.label }}
            </p>

            <p class="opacity-60 font-semibold text-xs">
              @if (
                version.status === ForecastVersionStatus.CALCULATING &&
                version.progress < 0.99
              ) {
                {{ version.progress | percent }}
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  </pm-form-input-select>
</pm-form-field>
